/**
 * EL NOMBRE DE UN CULTIVO EN LAS PANTALLAS DE «PLAGAS POR UBICACIÓN Y CULTIVO»
 * (plan cultivos SIEX F6, pantallas; 05-10-2026).
 *
 * El catálogo SIEX entero (`useCropCatalog`, ~1.120 cultivos) llega por red y
 * tarda: la tarjeta del asistente salió en la e2e del 05-10 con «Hemos visto que
 * cultivas #197 y #152» porque se pintó antes de que llegara. Mientras no está,
 * vale la etiqueta CURADA (`curados.ts`, síncrona, en los 9 idiomas), que cubre
 * los 10 cultivos de la lista curada de plagas v1 y los habituales de
 * invernadero. El `#código` queda solo para un cultivo que no está en ninguno
 * de los dos (y la tarjeta no se enseña mientras pase eso).
 */
import { etiquetaCultivo } from "@/components/crops/CropPicker";
import { cultivoCuradoPorCodigo, type IdiomaCultivo } from "@/lib/crops/curados";
import type { CultivoCatalogoItem } from "@/lib/crops/catalogo";

const idiomaDe = (lang: string) => ((lang || "es").split(/[-_]/)[0].toLowerCase() || "es") as IdiomaCultivo;

/** El nombre sin el `#código` de último recurso: null si no se sabe todavía. */
export function nombreCultivoConocido(
  code: number,
  items: readonly CultivoCatalogoItem[],
  lang: string,
): string | null {
  const item = items.find((c) => c.c === code);
  if (item) return etiquetaCultivo(item, lang);
  const curado = cultivoCuradoPorCodigo(code);
  if (!curado) return null;
  return curado.etiquetas?.[idiomaDe(lang)] ?? curado.visible;
}

/** El nombre para enseñar: el del catálogo, el curado o, si no, `#código`. */
export function nombreCultivo(code: number, items: readonly CultivoCatalogoItem[], lang: string): string {
  return nombreCultivoConocido(code, items, lang) ?? `#${code}`;
}
